import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { getAuth, signOut } from 'firebase/auth'

import {
  UNSUBSCRIBE,
  getUserSubscriptionsInfoUnifiedAction,
} from 'root-redux/actions/user'
import { selectActionList } from 'root-redux/selects/common'
import { TAppDispatch } from 'root-redux/store/store'

import { usePlanUpdateFakeDelay } from 'hooks/usePlanUpdateFakeDelay'

import { ICustomRouterState } from 'models/common.model'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'
import { SubscriptionDetailsTab } from 'root-constants'

export const useCanceledPlan = () => {
  const { search, state } = useLocation()
  const dispatch: TAppDispatch = useDispatch()
  const fetchingActionsList = useSelector(selectActionList)
  const isReadyToNextStep = usePlanUpdateFakeDelay()

  const isUnsubscribeInProgress = fetchingActionsList.includes(UNSUBSCRIBE)
  const isWithdrawal = (state as ICustomRouterState)?.isWithdrawal

  const signOutFirebase = useCallback(() => signOut(getAuth()), [])

  const goToAccountPage = async () => {
    await dispatch(getUserSubscriptionsInfoUnifiedAction(signOutFirebase))

    goTo({
      pathname: PageId.SUBSCRIPTION_DETAILS,
      search,
    })
  }

  useEffect(() => {
    if (isUnsubscribeInProgress || !isReadyToNextStep || !isWithdrawal) return

    goTo(
      {
        pathname: PageId.SUBSCRIPTION_DETAILS,
        search,
      },
      {
        defaultTab: SubscriptionDetailsTab.SUBSCRIPTIONS,
      },
    )
  }, [isUnsubscribeInProgress, isReadyToNextStep, isWithdrawal, search])

  return {
    isInProgress: isUnsubscribeInProgress || !isReadyToNextStep || isWithdrawal,
    goToAccountPage,
  }
}
